<div class="tw-flex tw-flex-col tw-w-full tw-gap-[8px]">
  <div class="tw-flex tw-justify-between tw-items-center tw-w-full tw-gap-[8px]">
    <label
      *tuiLet="value$ | async as value"
      class="tw-flex tw-items-center tw-gap-[8px] tw-cursor-pointer tw-flex-1 wo-multi-select-group-checkbox"
      [class.wo-multi-select-group-checkbox--small]="small"
    >
      <tui-checkbox
        [ngModel]="value"
        [disabled]="!!(disabled$ | async)"
        size="l"
        [size]="small ? 'm' : 'l'"
        (click)="onClick(value)"
      />
      <ng-container
        *ngIf="templateLabel"
        [ngTemplateOutlet]="templateLabel.template"
      />
      <div *ngIf="!templateLabel">{{ label }}</div>
    </label>
    <iss-expand-icon [(expanded)]="expanded"/>
  </div>
  <tui-expand [expanded]="expanded">
    <ng-content></ng-content>
  </tui-expand>
</div>
